(function (app) {

    app.provider("authService", [function () {
        this.$get = ["permissionService", "$cookies", "complianceHubBaseApiUrl", function (permissionService, $cookies, complianceHubBaseApiUrl) {
            return {
                login: login,
                logout: logout,
                isAuthenticated: isAuthenticated
            };

            function login() {
                var url = complianceHubBaseApiUrl + "/Login/Fig/Redirect/Auth0?redirectUri=" + window.encodeURIComponent(window.location.protocol + "//" + window.location.host);
                window.location = url;
            }

            function logout() {
                permissionService.removeStoredPermissions();
                permissionService.removeStoredOnBehalfOfUserId();
                window.location = complianceHubBaseApiUrl + "/Logout/Fig/Redirect";
            }

            function isAuthenticated() {
                // TODO: set timer for modal
                var timerCookie = $cookies.get(".timer.icomply");
                console.log("checking cookie", document.cookie, timerCookie);
                if (!timerCookie) return false;
                var expiration = new Date(timerCookie);
                if (window.isNaN(expiration.getTime())) return false;
                return expiration > new Date();
            }
        }];
    }]);

    app.run(["complianceHubApiGateway", function (api) {
        api.addInterceptor([function () {
            return {
                request: function (config) {
                    config.withCredentials = true;
                    return config;
                }
            };
        }]);
    }]);

    app.run([
        "complianceHubApiGateway", function (api) {
            api.addInterceptor([
                "permissionService", function (permissionService) {
                    return {
                        request: function (config) {
                            var id = permissionService.getOnBehalfOfUserId();
                            if (id)
                                config.headers["X-On-Behalf-Of"] = id;
                            return config;
                        }
                    };
                }
            ]);
        }
    ]);

    //temporary
    app.run(["authService", "complianceHubApiGateway", function (auth, api) { window.auth = auth; window.api = api; }]);

})(window.app); //jshint ignore:line